import { isCommercialSelector } from 'shared/selectors/offerData/offer/isCommercialSelector';

import { IState } from '../../store';
import { abUseExperimentsSelector, isAbUseExperimentsActive } from '../abUseExperiments';

export const INFRASTRUCTURE_MF_EXPERIMENT = 'aud_desktop_aud2556_unified_infrastructure';

export const selectIsInfrastructureMicrofrontendExperimentEnabled = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);
  const isCommercial = isCommercialSelector(state);

  return (
    !isCommercial &&
    state.featureToggle.infrastructureMicrofrontendEnabled &&
    isAbUseExperimentsActive(experiments, INFRASTRUCTURE_MF_EXPERIMENT, 'B')
  );
};
